import { useCorporateFormContext } from 'src/components/enterprise/features/Corporate/components/Form/CorporateFormProvider/useCorporateFormContext';
import { transformCorpMerchantRestrictionsToMeta } from 'src/components/enterprise/features/Corporate/components/Form/MerchantRestrictionsWrapper/merchantRestrictions.utils';
import {
  GroupRestrictions,
  groupRestrictions,
} from 'src/common/OrderRestrictions/orderRestrictions.utils';

import {
  useOrderRestrictionContext,
  OrderRestrictionsContextType,
} from 'src/common/OrderRestrictions/OrderRestrictionsProvider/OrderRestrictionsProvider';

type UseCorporateMerchantRestrictionsReturn = {
  groupedMerchantRestrictions: GroupRestrictions;
} & OrderRestrictionsContextType;

export function useCorporateMerchantRestrictions(): UseCorporateMerchantRestrictionsReturn {
  const { corpData } = useCorporateFormContext();
  const { isLoading, merchantRestrictionsMeta, error } =
    useOrderRestrictionContext();

  const getGroupedMerchantRestrictions = (): GroupRestrictions => {
    if (error && corpData?.defaultMerchantRestrictions) {
      return groupRestrictions(
        transformCorpMerchantRestrictionsToMeta(
          corpData.defaultMerchantRestrictions
        )
      );
    }
    return groupRestrictions(merchantRestrictionsMeta || []);
  };

  return {
    merchantRestrictionsMeta,
    isLoading,
    groupedMerchantRestrictions: getGroupedMerchantRestrictions(),
  };
}
